<template lang='pug'>
.content.relation-content
  .row.relation-body
    .col-md-12
      .header Bạn bè
      .row
        .col-xs-4.col-md-4.col-linked
          .card.card-relation-total
            .box-relation-total
              .img-relation
                img(src="../../assets/images/faces/ic_linked.svg")
              .amount-relation
                .cur-total 
                  div Đã liên kết
                  div {{formatNumber(linkedTotal)}}
        .col-xs-4.col-md-4.col-link-waiting
          .card.card-relation-total
            .box-relation-total
              .img-relation
                img(src="../../assets/images/faces/ic_link_waiting.svg")
              .amount-relation
                .cur-total 
                  div Chờ bạn xác nhận
                  div {{formatNumber(linkWaiting)}}
        .col-xs-4.col-md-4.col-link-question
          .card.card-relation-total
            .box-relation-total
              .img-relation
                img(src="../../assets/images/faces/ic_link_question.svg")
              .amount-relation
                .cur-total 
                  div Đã gửi yêu cầu
                  div {{formatNumber(linkQuestion)}}
    .col-md-12
      .btn-relation-list
        button.btn.btn-relation-add-request(@click="onAddRelation") Thêm liên kết
    .col-md-12
      .card.card-relation-action
        .box-table-relation(v-on:scroll.passive='handleScroll' v-if="!mobile")
          tableRelation(
            @onAccept='accept',
            @onRefuse='refuse',
            @onCancelLink='cancelLink',
            @onCancelRequest='cancelRequest',
            @onRemoveRequest='removeRequest',
            @onfilterbystatus="filterbystatus",
            @onfilterbytype="filterbytype",
            @onSendLink="sendLink",
            :data='relations',
            :columns='columns',
            :inlineFilter='true',
            :lstStatus='lstStatus',
            :lstType='lstType'
          )
        .box-table-relation-kanban(v-else)
          .box-filter
            .col-xs-4.text-right
              span Quan hệ
            .col-xs-8.text-left
              select#type(@change="filterbytype($event.target.value)")
                option(value='') Tất cả
                option(v-for='(o, i) in lstType' :value='o.key') {{o.value}}
            .clearfix
          .box-filter.filter-status
            .col-xs-4.text-right
              span Trạng thái
            .col-xs-8
              select#status(@change="filterbystatus($event.target.value)")
                option(value='') Tất cả
                option(v-for='(o, i) in lstStatus' :value='o.key') {{o.value}}
            .clearfix
          .box-list
            .box-list-items(v-for='(item, index) in relations')
              .fullname
                .img-avt(v-if='item.user_id_request === $store.getters.user')
                  img(:src='item.userRequested.avatar !== null && item.userRequested.avatar || require("../../assets/images/faces/ic_AvatarDefault.svg")')
                .img-avt(v-else-if='item.user_id_requested === $store.getters.user')
                  img(:src='item.userRequest.avatar !== null && item.userRequest.avatar || require("../../assets/images/faces/ic_AvatarDefault.svg")')
                span {{item.user_id_request === $store.getters.user ? item.userRequested.fullname : item.userRequest.fullname}}
              .box-type
                .col-xs-4
                  span Quan hệ
                .col-xs-8.text-left
                  select#type(@change="onTypeChange($event)")
                    option(v-for='(o, i) in lstType' :value='o.key' :selected="o.key === item.type") {{o.value}}
                .clearfix
              .box-status
                .col-xs-4
                  span Trạng thái
                .col-xs-8.text-left
                  span {{getStatus(item)}}
                .clearfix
              .box-accept-refuse(v-if='item.status === 1 && item.user_id_requested === $store.getters.user')
                .box-action(@click='refuse(item)')
                  .box-item-refuse
                    img(src="../../assets/images/faces/ic_clear.svg")
                  span Từ chối
                .box-action(@click='accept(item)')
                  .box-item-check
                    img(src="../../assets/images/faces/ic_check.svg")
                  span Chấp nhận
              .box-dot(v-if='item.status === 1 && item.user_id_request === $store.getters.user')
                .col-xs-10
                .col-xs-2(:id='"action" + item.id')
                  i.material-icons.text-gray(style="cursor:pointer; line-height:0;") more_horiz
                  b-popover(:target='"action" + item.id' triggers="hover" placement="bottom") 
                    template
                      div(style="width: 110px; height: 40px; background: #E0E0E0 0% 0% no-repeat padding-box;box-shadow: 0px 1px 0px #00000029;opacity: 1;")
                        .cancel-link(v-if="item.status === 2" @click="cancelLink(item)" style="cursor:pointer; text-align: center; color: #23180A; padding-top: 8px; font-size: 15px;") Hủy kết bạn
                        .cancel-request(v-if="item.status === 1" @click="cancelRequest(item)" style="cursor:pointer; text-align: center; color: #23180A; padding-top: 8px; font-size: 15px;") Hủy yêu cầu
                        .remove-request(v-if="item.status === 3" @click="removeRequest(item)" style="cursor:pointer; text-align: center; color: #23180A; padding-top: 8px; font-size: 15px;") Xóa yêu cầu
              .box-dot(v-if='item.status !== 1')
                .col-xs-10
                .col-xs-2(:id='"action" + item.id')
                  i.material-icons.text-gray(style="cursor:pointer; line-height:0;") more_horiz
                  b-popover(:target='"action" + item.id' triggers="hover" placement="bottom") 
                    template
                      div(style="width: 110px; height: 40px; background: #E0E0E0 0% 0% no-repeat padding-box;box-shadow: 0px 1px 0px #00000029;opacity: 1;")
                        .cancel-link(v-if="item.status === 2" @click="cancelLink(item)" style="cursor:pointer; text-align: center; color: #23180A; padding-top: 8px; font-size: 15px;") Hủy kết bạn
                        .cancel-request(v-if="item.status === 1" @click="cancelRequest(item)" style="cursor:pointer; text-align: center; color: #23180A; padding-top: 8px; font-size: 15px;") Hủy yêu cầu
                        .remove-request(v-if="item.status === 3" @click="removeRequest(item)" style="cursor:pointer; text-align: center; color: #23180A; padding-top: 8px; font-size: 15px;") Xóa yêu cầu
          
</template>

<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import tableRelation from './tableRelation'
import MdNotification from '@/core/components/mdNotification'
import inputCustom from './inputCustom'
import moment from 'moment'
export default {
  components: {tableRelation, MdNotification, inputCustom},
  data() {
    return {
      linkedTotal: 0,
      linkWaiting: 0,
      linkQuestion: 0,
      limit: 10,
      offset: 0,
      relations: [],
      columns: [
        { key: 'seq', type: 'seq' },
        { key: 'userRequested' },
        { key: 'type', type: 'type' },
        { key: 'status', type: 'status' },
        { key: 'created_at', type: 'date' },
        { key: 'action', type: 'custom' }
      ],
      lstStatus: [
        {key: 0, value: 'Đã gửi yêu cầu'},
        {key: 1, value: 'Chờ bạn xác nhận'},
        {key: 2, value: 'Đã liên kết'},
        {key: 3, value: 'Bị từ chối'}
      ],
      lstType: [
        {key: 3, value: 'Giáo viên'},
        {key: 1, value: 'Bạn bè'},
        {key: 2, value: 'Bạn đồng hành'}
      ],
      filter: null,
      filterStatus: null,
      filterType: null,
      uid: null,
      uid_requested: null,
      mobile: false
    }
  },
  filters: {
    moment(date) {
      return moment(date).format('DD/MM/YYYY - hh:mm') // format (h:mm:ss a)
    }
  },
  methods: {
    onAddRelation() {
      // this.showNotification('Đang xây dựng', 'warning', 'top', 'right', 5000)
      this.$router.push('relation-add')
    },
    sendLink(data) {
      // console.log(data)
    },
    isMobile() {
      if (window.innerWidth < 991) {
        return true
      }
      return false
    },
    formatNumber(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    },
    async getTotal(status) {
      var res = await this.$apollo.query({
        query: gql(graphql.GET_RELATION_USER),
        variables: {
          uid: this.$store.getters.user,
          status: status
        }
      })
      if (res) {
        // console.log(res.data.relation_aggregate.aggregate)
        if (status === 2) this.linkedTotal = (res.data.relation_aggregate.aggregate.count + res.data.alias_aggregate.aggregate.count)
        else if (status === 1) this.linkQuestion = res.data.relation_aggregate.aggregate.count
      }
    },
    async getTotal2(status) {
      var res = await this.$apollo.query({
        query: gql(graphql.GET_RELATION_USER),
        variables: {
          uid: this.$store.getters.user,
          status: status
        }
      })
      if (res) {
        // console.log(res.data.alias_aggregate.aggregate)
        this.linkWaiting = res.data.alias_aggregate.aggregate.count
      }
    },
    handleScroll(e) {
      if ((e.target.scrollHeight - 385) === Math.round(e.target.scrollTop) || (e.target.scrollHeight - 385) === Math.floor(e.target.scrollTop)) {
        this.limit = this.relations.length + 10
      }
      // console.log(Math.round(e.target.scrollTop))
      // console.log(e.target.scrollHeight)
    },
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    accept(payload) {
      // console.log('accept', payload.id)
      try {
        this.$modal.show('dialog', {
          title: 'Xác nhận',
          text: 'Bạn có chắc đồng ý với yêu cầu liên kết này không?',
          buttons: [
            {
              title: 'Có',
              default: true,
              handler: () => {
                this.$apollo.mutate({
                  mutation: gql(graphql.UPDATE_RELATION_USER),
                  variables: {
                    id: payload.id,
                    status: 2
                  }
                }).then((data) => {
                  // Result
                  this.$apollo.queries.relations.refetch()
                  this.linkedTotal++
                  this.linkWaiting--
                  this.showNotification('Liên kết đã được chấp nhận', 'success', 'top', 'right', 7000)
                  this.$modal.hide('dialog')
                }).catch((error) => {
                  // Error
                  console.error(error)
                })
              }
            },
            {
              title: 'Hủy'
            }
          ]
        })
      } catch (e) {
        console.error(e)
      }
    },
    refuse(payload) {
      // console.log('refuse', payload.id)
      try {
        this.$modal.show('dialog', {
          title: 'Xác nhận',
          text: 'Bạn có chắc từ chối yêu cầu liên kết này không?',
          buttons: [
            {
              title: 'Có',
              default: true,
              handler: () => {
                this.$apollo.mutate({
                  mutation: gql(graphql.UPDATE_RELATION_USER),
                  variables: {
                    id: payload.id,
                    status: 3
                  }
                }).then((data) => {
                  // Result
                  this.$apollo.queries.relations.refetch()
                  this.linkWaiting--
                  this.showNotification('Liên kết đã bị từ chối', 'success', 'top', 'right', 7000)
                  this.$modal.hide('dialog')
                }).catch((error) => {
                  // Error
                  console.error(error)
                })
              }
            },
            {
              title: 'Hủy'
            }
          ]
        })
      } catch (e) {
        console.error(e)
      }
    },
    cancelLink(payload) {
      try {
        this.$modal.show('dialog', {
          title: 'Xác nhận',
          text: 'Bạn có chắc muốn hủy liên kết hay không?',
          buttons: [
            {
              title: 'Có',
              default: true,
              handler: () => {
                this.$apollo.mutate({
                  mutation: gql(graphql.DELETE_RELATION),
                  variables: {
                    id: payload.id
                  }
                }).then((data) => {
                  // Result
                  this.$apollo.queries.relations.refetch()
                  this.linkedTotal--
                  this.showNotification('Đã hủy liên kết', 'success', 'top', 'right', 7000)
                  this.$modal.hide('dialog')
                }).catch((error) => {
                  // Error
                  console.error(error)
                })
              }
            },
            {
              title: 'Hủy'
            }
          ]
        })
      } catch (e) {
        console.error(e)
      }
    },
    cancelRequest(payload) {
      try {
        this.$modal.show('dialog', {
          title: 'Xác nhận',
          text: 'Bạn có chắc muốn hủy yêu cầu hay không?',
          buttons: [
            {
              title: 'Có',
              default: true,
              handler: () => {
                this.$apollo.mutate({
                  mutation: gql(graphql.DELETE_RELATION),
                  variables: {
                    id: payload.id
                  }
                }).then((data) => {
                  // Result
                  this.$apollo.queries.relations.refetch()
                  // this.getTotal(2)
                  // this.getTotal2(1)
                  // this.getTotal(1)
                  this.linkQuestion--
                  this.showNotification('Đã hủy yêu cầu', 'success', 'top', 'right', 7000)
                  this.$modal.hide('dialog')
                }).catch((error) => {
                  // Error
                  console.error(error)
                })
              }
            },
            {
              title: 'Hủy'
            }
          ]
        })
      } catch (e) {
        console.error(e)
      }
    },
    removeRequest(payload) {
      try {
        this.$modal.show('dialog', {
          title: 'Xác nhận',
          text: 'Bạn có chắc muốn xóa yêu cầu hay không?',
          buttons: [
            {
              title: 'Có',
              default: true,
              handler: () => {
                this.$apollo.mutate({
                  mutation: gql(graphql.DELETE_RELATION),
                  variables: {
                    id: payload.id
                  }
                }).then((data) => {
                  // Result
                  this.$apollo.queries.relations.refetch()
                  this.showNotification('Đã xóa yêu cầu', 'success', 'top', 'right', 7000)
                  this.$modal.hide('dialog')
                }).catch((error) => {
                  // Error
                  console.error(error)
                })
              }
            },
            {
              title: 'Hủy'
            }
          ]
        })
      } catch (e) {
        console.error(e)
      }
    },
    filterbytype(type) {
      // console.log(type)
      if (type === '') this.filterType = null
      this.filterType = type
    },
    filterbystatus(status) {
      if (status === '' || status === null || status === undefined) {
        this.filterStatus = null
        this.$apollo.queries.relations.refresh()
      } else if (status === '1') {
        this.refreshRelation(1)
      } else if (status === '0') {
        this.refreshRelation(0)
      } else {
        this.filterStatus = status
      }
    },
    getStatus(item) {
      for (let i = 0; i < this.lstStatus.length; i++) {
        if (item.status === this.lstStatus[i].key) {
          if (item.user_id_request === this.$store.getters.user && this.lstStatus[i].key === 1) return 'Đã gửi yêu cầu'
          else return this.lstStatus[i].value
        }
      }
    },
    refreshRelation(status) {
      let variables = {
        uid: status === 0 && this.$store.getters.user || null,
        status: 1,
        uid_requested: status === 1 && this.$store.getters.user || null
      }
      // console.log(variables)
      this.$apollo.query({
        query: gql(graphql.GET_RELATIONS_FILTER_CONDITION),
        variables: variables
      }).then((res) => {
        // console.log(res)
        this.relations = (status === 0) && res.data.relation || res.data.alias
      })
    }
  },
  created() {
    this.getTotal(2)
    this.getTotal2(1)
    this.getTotal(1)
    // if (this.$store.getters.sentRequest !== null && this.$store.getters.sentRequest > 0) {
    //   console.log('back params', this.$store.getters.sentRequest)
    //   this.linkQuestion += this.$route.params.action_sent_request
    // }
  },
  mounted() {
    if (window.innerWidth < 991) {
      this.mobile = true
    } else {
      this.mobile = false
    }
  },
  apollo: {
    relations: {
      query: gql(graphql.GET_RELATIONS_FILTER),
      fetchPolicy: 'no-cache',
      variables() {
        return {
          uid: this.$store.getters.user,
          status: this.filterStatus !== '' ? this.filterStatus : null,
          type: this.filterType !== '' ? this.filterType : null,
          offset: this.offset,
          limit: this.limit
        }
      },
      update: data => {
        var lstRelations = []
        var tmpRelation = data.relation
        var tmpAlias = data && data.alias.length > 0 && data.alias
        lstRelations = [...tmpAlias, ...tmpRelation]
        for (let i = 0; i < lstRelations.length; i++) {
          lstRelations[i].action = 'action' + lstRelations[i].id
        }
        lstRelations.sort(function(a, b) {
          var dateA = new Date(a.created_at)
          var dateB = new Date(b.created_at)
          return dateB - dateA
        })
        // console.log(lstRelations)
        return lstRelations
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.relation-content {
  padding-top: 20px !important;
}
.relation-body {
  .header {
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    color: #5F6468;
  }
  // total
  .col-linked {padding-right: 7.5px;}
  .col-link-waiting {padding-right: 7.5px; padding-left: 7.5px;}
  .col-link-question {padding-left: 7.5px;}
  .card-relation-total {
    margin-bottom: 5px;
    margin-top: 15px;
    border-radius: 5px;
    .box-relation-total {
      padding: 15px 0 15px 15px;
      .img-relation {
        width: 48px;
        display: inline-flex;
        img {max-width: 100%; height: auto; width: 100%;}
      }
      .amount-relation {
        color: #9B9B9B;
        display: inline-block;
        margin-left: 15px;
        width: calc(100% - 65px);
        .cur-total {
          div:first-child {padding-bottom: 10px; font-size: 15px;}
          div:last-child {color: #9F6A28; font-size: 24px; font-weight: bold;}
        }
      }
    }
  }
  .btn-relation-list {
    .btn-relation-add-request {
      background-color: #FFD311;
      width: 160px;
      height: 48px;
      border-radius: 5px;
      color: black;
      text-transform: none;
      font-size: 14px;
      font-family: 'adobe-clean' sans-serif;
      border: 1px solid #FFD311;
      padding: 0;
      &:active {
        background-color: #CCAD7B;
        color: black;
      }
    }
    .btn-relation-manage-request {
      background-color: #FAFAFA;
      width: 160px;
      height: 48px;
      border-radius: 5px;
      color: black;
      text-transform: none;
      font-size: 14px;
      font-family: 'adobe-clean' sans-serif;
      border: 1px solid #FAFAFA;
      padding: 0;
      margin-left: 15px;
      &:active {
        background-color: #EAEAEA;
        color: black;
      }
    }
  }
  // danh sach lien ket table
  .card-relation-action {
    margin-top: 5px;
    background: white;
    border-radius: 10px;
    .box-table-relation {
      background: #FFFFFF 0% 0% no-repeat padding-box;
      box-shadow: 0px 1px 3px #00000029;
      padding: 10px;
      max-height: 385px; overflow-y: scroll;
      border-radius: 10px;
    }
    .box-table-relation-kanban {display: none;}
  }
  // danh sach lien ket div
  .card {
    .card-content {
      .box-list-relation {
        .box-relation-header {
          background: #EAEAEA;
          width: 100%;
          height: 40px;
          .filter-type {
            position: relative;
            display: inline-block;
            margin-left: 30%;
            margin-top: 10px;
            select#type {max-width: 100%; height: auto;}
          }
          .filter-status {
            position: absolute;
            display: inline-block;
            margin-left: 10px;
            margin-top: 10px;
            select#fstate {max-width: 100%; height: auto;}
          }
        }
        .box-relation-scroll {
          .box-relation-items {
            position: relative;
            padding: 20px 0 10px;
            font-size: 15px !important;
            color: black;
            span {font-size: 100px;}
          }
        }
      }
    }
  }
}
@media (max-width: 414px) {
  .relation-content {
    padding-top: 0px !important;
  }
  .relation-body {
    // total
    .col-linked {padding-right: 0.5px;}
    .col-link-question {padding-left: 0.5px;}
    .card-relation-total {
      .box-relation-total {
        padding: 15px 0;
        .img-relation {
          margin: 0 auto; display: block;
        }
        .amount-relation {
          color: #9B9B9B;
          display: block;
          margin-left: 0px;
          width: 100%;
          text-align: center;
          .cur-total {
            div:first-child {padding-bottom: 10px; font-size: 15px;min-height: 52px;margin-top: 10px;}
          }
        }
      }
    }
    // danh sach lien ket
    .card-relation-action {
      .box-table-relation {display:none;}
      .box-table-relation-kanban {
        display: block;
        background: #FFFFFF 0% 0% no-repeat padding-box;
        text-align: center;
        padding: 15px;
        border-radius: 5px;
        position: relative;
        .box-filter {
          background: #EAEAEA;
          height: 36px;
          line-height: 33px;
          padding: 1px;
          &.filter-status {padding-top: 0;}
          .col-xs-4 {
            background: #FAFAFA;
          }
          .col-xs-8 {
            border: 1px solid #E0E0E0;
            background: #EAEAEA;
          }
          span {
            font-family: 'adobe-clean', sans-serif;
            font-size: 15px;
            font-weight: bold;
            color: #343A40;
            opacity: 1;
          }
          select {
            width: 100%;
            background: #FFFFFF 0% 0% no-repeat padding-box; 
            border: 1px solid #B4B4B4; 
            border-radius: 10px; 
            opacity: 1; 
            padding: 3px;
          }
        }
        .box-list-items {
          border: 1px solid #E0E0E0;
          background: #FAFAFA;
          margin-top: 10px;
          border-radius: 5px;
          &:first-child {margin-top: 15px;}
          .fullname {
            text-align: left;
            margin: 10px 10px 0 10px;
            display: flex;
            align-items: center;
            .img-avt {
              width: 48px;
              height: 48px;
              display: inline-block;
              margin-right: 10px;
              border-radius: 50%;
              overflow: hidden;
              img {max-width: 100%; height: auto; }
            }
            span {font-size: 15px; color: #9F6A28; font-weight: bold;}
          }
          .box-type {
            height: 40px;
            line-height: 37px;
            padding: 1px;
            .col-xs-4 {
              font-family: 'adobe-clean', sans-serif;
              color: #4B2D15;
              font-size: 12px;
              font-weight: bold;
              text-align: left;
              padding-left: 10px;
            }
            .col-xs-8 {
              padding-left: 0;
              select {
                width: 100%;
                background: #FFFFFF 0% 0% no-repeat padding-box; 
                border: 1px solid #B4B4B4; 
                border-radius: 10px; 
                opacity: 1; 
                padding: 6px;
                color: #000000;
              }
            }
          }
          .box-status {
            height: 27px;
            line-height: 24px;
            padding: 1px;
            .col-xs-4 {
              font-family: 'adobe-clean', sans-serif;
              color: #4B2D15;
              font-size: 12px;
              font-weight: bold;
              text-align: left;
              padding-left: 10px;
            }
            .col-xs-8 {
              padding-left: 0;
            }
          }
          .box-accept-refuse {
            display: block;
            height: 30px;
            text-align: right;
            padding: 0 15px;
            .box-action {
              .box-item-check {
                width: 24px;
                margin-left: 14.41px;
                img {max-width: 100%; height: auto;}
              }
              .box-item-refuse {
                width: 24px;
                img {max-width: 100%; height: auto;}
              }
              span {padding-top: 4px; padding-left: 7px; font-size: 13px;}
            }
          }
          .box-dot {
            width: 100%;
            display: inline-block;
            .popover.b-popover {
              display: block;
              opacity: 1;
              outline: 0;
            }
            .popover {
              top: 0;
              left: 0;
              z-index: 1060;
              max-width: 276px;
              font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
              font-style: normal;
              font-weight: 400;
              line-height: 1.5;
              text-align: left;
              text-decoration: none;
              text-shadow: none;
              text-transform: none;
              letter-spacing: normal;
              word-break: normal;
              word-spacing: normal;
              white-space: normal;
              line-break: auto;
              // font-size: .875rem;
              word-wrap: break-word;
              background-color: #fff;
              background-clip: padding-box;
              border: 1px solid rgba(0,0,0,.2);
              border-radius: .3rem;
            }
            .cancel-request, .remove-request,
            .cancel-link{
              &:hover {color: green !important;}
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?13915639